import type { EnvironmentSummary } from '../api/client.ts';

export function EnvironmentSwitcher(props: {
  environments: EnvironmentSummary[];
  currentId: string;
  onChange: (environmentId: string) => void;
}) {
  return (
    <label className="env-switcher">
      <span className="visually-hidden">Environment</span>
      <select
        aria-label="Environment"
        value={props.currentId}
        onChange={(event) => props.onChange(event.target.value)}
      >
        {props.environments.map((env) => (
          <option key={env.id} value={env.id}>
            {env.name}
          </option>
        ))}
      </select>
    </label>
  );
}
